/* @flow */
import * as React from 'react';

import LinkConstants from 'constants/LinkConstants';
import { SKIP_URGENT_MESSAGING_INFO_DIALOG_COOKIE } from 'chat/constants/ChatConstants';
import { SplitComposerModal } from 'chat/components/SplitComposer';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Checkbox from 'components/Checkbox';
import Cookies from 'lib/Cookies';
import Dialog from 'components/Dialog';
import Image from 'components/Image';
import Heading from 'components/Heading';
import ModalTrigger from 'components/ModalTrigger';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

import UrgentAnnouncementImage from 'assets/images/SplitComposer/urgent.svg';

import type { OrganizationTarget, GroupTarget } from 'entities/Message';

type Props = {
  triggerComposerOnContinue?: boolean,
  initialTargets?: ?((GroupTarget | OrganizationTarget)[]),
  showCheckboxToSkip?: boolean,
  onRequestHide: () => void,
};

type State = {
  skipUrgentMessagingDialog: boolean,
};

export default class UrgentMessagingLearnMoreDialog extends React.Component<Props, State> {
  state = {
    skipUrgentMessagingDialog: false,
  };

  handleContinue = () => {
    if (this.state.skipUrgentMessagingDialog) {
      Cookies.set(SKIP_URGENT_MESSAGING_INFO_DIALOG_COOKIE, 'true');
    }
    this.props.onRequestHide();
  };

  renderContinue = () => {
    const continueButton = (
      <Button
        full
        onClick={this.handleContinue}
        data-test="urgent-messaging-learn-more-continue-button">
        Continue
      </Button>
    );
    if (this.props.triggerComposerOnContinue) {
      return (
        <ModalTrigger
          modal={
            <SplitComposerModal initialTargets={this.props.initialTargets} messageType="urgent" />
          }>
          {continueButton}
        </ModalTrigger>
      );
    }
    return continueButton;
  };

  render() {
    const { onRequestHide, showCheckboxToSkip } = this.props;
    return (
      <Dialog size="small" onRequestHide={onRequestHide}>
        <BoxBody>
          <Row size="small">
            <Image width={50} src={UrgentAnnouncementImage} />
          </Row>
          <Row>
            <Heading>Urgent messages reach everyone</Heading>
          </Row>
          <Text lineHeight="xlarge">
            <Row size="small">
              <TextWithIcon
                gutter="medium"
                iconSize="large"
                icon="replies"
                iconColor="thunder"
                color="thunder">
                Notifications will be sent to people who have opted out of messages.
              </TextWithIcon>
            </Row>
            <Row>
              <TextWithIcon
                gutter="medium"
                iconSize="large"
                icon="phone-ringing"
                iconColor="thunder"
                color="thunder">
                Landline-only recipients will receive a text-to-speech call.
              </TextWithIcon>
            </Row>
          </Text>
          {showCheckboxToSkip && (
            <Row size="medium">
              <Checkbox
                data-test="skip-dialog-checkbox"
                label="Don’t show this again"
                checked={this.state.skipUrgentMessagingDialog}
                onChange={() =>
                  this.setState({
                    skipUrgentMessagingDialog: !this.state.skipUrgentMessagingDialog,
                  })
                }
              />
            </Row>
          )}
          <Buttons axis="y">
            {this.renderContinue()}
            <Button
              full
              size="xxxsmall"
              level="text"
              color="brand"
              href={LinkConstants.URGENT_MESSAGING_HELP}
              target="_blank">
              <Text weight="semibold">Learn more</Text>
            </Button>
          </Buttons>
        </BoxBody>
      </Dialog>
    );
  }
}
